import { uri } from '../../api-endpoint';
import { ICsvFromAPISuccessResponse } from '../../type-conversion/csv/from-api-response';
import { fetchListTemplateFn } from '../common';

export const fetchCsvListAPI = (token: string) =>
  fetchListTemplateFn(token, uri.exporterCsvList(), ICsvFromAPISuccessResponse);
